import get from 'lodash/get'
import cloneDeep from 'lodash/cloneDeep'
// must be devided by 24
export const FormModes = {
  COMPACT: {
    cols: 6
  },
  DENSE: {
    cols: 5
  },
  NORMAL: {
    cols: 4
  },
  SPARSE: {
    cols: 3
  },
  LOOSE: {
    cols: 2
  },
  SINGLE: {
    cols: 1
  }
}

export const All = 'All'

export const Number = 'number'
export const String = 'string'
export const Time = 'time'
export const Enum = 'enum'
export const Ref = 'reference'
export const Array = 'array'
export const TObject = 'object'
export const Boolean = 'boolean'
export const JSON = 'json'

export const TrueStatus = 'True'
export const FalseStatus = 'False'
export const TrueOrFalseOptions = [TrueStatus, FalseStatus]

// used by basic form
export const Tag = 'tag' // display as tag
export const AddressTag = 'addressTag'
export const Text = 'text' // display as text
export const ReferenceObject = 'object' //
export const TextInput = 'textInput'
export const TextArea = 'textArea'
export const TimeSelect = 'timeSelect'
export const AddressSelect = 'addressSelect'
export const SlotType = 'slot'
export const StockGroupSelect = 'stockGroupSelect'
export const DateSelect = 'dateSelect'
export const TimeRange = 'timeRange'
export const TimeTargetSelect = 'timeTargetSelect'
export const NumberInput = 'numberInput'
export const Select = 'select'
export const RemoteSelect = 'remoteSelect'
export const IconUpload = 'iconUpload'
export const Blank = 'blank'
export const Checkbox = 'checkbox'
export const RadioGroup = 'radioGroup'
export const HoldTag = 'holdTag'
export const Progress = 'progress'
export const Switch = 'switch'
export const Link = 'link'
export const HoldSelect = 'holdSelect'
export const EditFormItemTypes = [
  TextInput,
  TextArea,
  TimeSelect,
  Switch,
  DateSelect,
  AddressSelect,
  AddressTag,
  HoldTag,
  HoldSelect,
  TimeRange,
  Select,
  RemoteSelect,
  StockGroupSelect,
  TimeTargetSelect,
  NumberInput,
  IconUpload,
  Blank,
  Checkbox,
  SlotType,
  RadioGroup
]

export const PrependText = 'prepend-text'
export const PrependSelect = 'prepend-select'

export const TimeFormat = "yyyy-MM-dd'T'HH:mm:ss"

export const DefaultValidator = () => [true, null]

export function RequiredNotEmptyListValidator(target) {
  if (target && target.length === 0) return [false, 'at least one element']
  return [true, '']
}

export function RequiredValidator(value) {
  const flag = value !== '' && value !== null && value !== undefined
  return [flag, flag ? '' : 'Required!']
}

export function NoSpaceOrDash(value) {
  if (value == null || typeof value !== 'string') return [true, '']
  const flag = value.includes(' ') || value.includes('-')
  if (flag) return [false, 'space or dash']
  return [true, '']
}

export function OnlyCapLetters(value) {
  if (value == null || value === '') return [true, '']
  if (!/^[A-Z]{4}$/.test(value)) {
    return [false, 'only 4 uppercase']
  }
  return [true, '']
}

export function ValidARNNo(value) {
  if (/^\d{11}$/.test(value)) return [true, '']
  return [false, '11 digits with numbers']
}

export function ValidPoNumber(value) {
  const flag1 = /^[A-Za-z0-9]{8}$/.test(value)
  const flag2 = /^[A-Za-z0-9]{6}$/.test(value)
  if (flag1 || flag2) return [true, '']
  return [false, '8/6 digits with letters or numbers']
}

export function PositiveValidator(value) {
  const flag = /^\d+$/.test(value)
  if (flag) {
    return [true]
  }
  return [false, 'Should be a valid positive integer!']
}

export function PositiveFloatValidator(value) {
  const num = parseFloat(value)
  if (num && num > 0) {
    return [true]
  }
  return [false, 'Positive number!']
}

export function EnumValidator(value) {
  const flag = this.options.includes(value)
  return [flag, flag ? '' : 'Please select a valid option!']
}

export function ZipCodeCheck(zipCode) {
  const reg = /(^\d{5}$)|(^\d{5}-\d{4}$)/
  const flag = reg.test(zipCode)
  return [flag, 'Invalid zip code']
}

export function FactoryCodeCheck(code) {
  if (code) {
    const reg = /(^[A-Z][A-Za-z0-9\s]{0,50}$)/
    const flag = reg.test(code)
    return [flag, 'Invalid factory code']
  }
  return [true, '']
}

// common tabs used for all pages
export const PackingTab = {
  label: 'Packing List',
  key: 'packing-list'
}
export const NotesTab = {
  label: 'Notes',
  key: 'notes'
}
export const EventsTab = {
  label: 'Events',
  key: 'events'
}
export const PalletListTab = {
  label: 'Pallet List',
  key: 'pallets'
}
export const PickingUpInfoTab = {
  label: 'Picking Info',
  key: 'picking-info'
}
export const JobsTab = {
  label: 'Jobs',
  key: 'jobs'
}

export function SearchFormRowColsCal(array, ColNum) {
  const rowCols = []
  let curRow = []
  let i = 0
  let span = 1
  let curSpan = 0
  while (i < array.length) {
    const comps = []
    const searchItem = array[i]
    const { type } = searchItem
    if ([TextInput, NumberInput, TimeSelect, AddressSelect, RemoteSelect].includes(type)) {
      span = 1
    } else if ([Select].includes(type)) {
      span = searchItem.multiple ? 2 : 1
    } else if ([TimeRange].includes(type)) {
      span = 2
    } else {
      span = 0
    }
    comps.push({
      ...searchItem,
      span
    })
    if (span + curSpan > ColNum) {
      rowCols.push(curRow)
      curRow = []
      curSpan = 0
    } else {
      curRow.push(...comps)
      curSpan += span
      i += 1
    }
  }
  rowCols.push(curRow)
  return rowCols
}

export function BasicFormRowColCal(array, ColNum, EmptyNode) {
  const rowCols = []
  let curRow = []
  let row = 0
  let i = 0
  while (i < array.length) {
    let { span } = array[i]
    span = span < 0 ? ColNum : span > ColNum ? ColNum : span
    if (row + span > ColNum) {
      // append rest
      for (let j = 0; j < ColNum - row; j++) {
        curRow.push({
          ...EmptyNode
        })
      }
      row = 0
      rowCols.push(curRow)
      curRow = []
    } else {
      row += span
      curRow.push({
        ...array[i],
        span
      })
      i += 1
    }
  }
  rowCols.push(curRow)
  return rowCols
}
const GMT0 = '.000+00:00'

export const TimeLocalDate = timeStamp => {
  if (timeStamp === '' || !timeStamp) return ''
  try {
    const date = new Date(timeStamp + GMT0)
    return date.toLocaleDateString()
  } catch (e) {
    return 'error time'
  }
}

export const TimeLocalTime = timeStamp => {
  if (timeStamp === '' || !timeStamp) return ''
  try {
    const date = new Date(timeStamp + GMT0)
    const timeString = date.toLocaleTimeString()
    return timeString
  } catch (e) {
    return 'error time'
  }
}

function formatAMPM(date) {
  let hours = date.getHours()
  // const minutes = date.getMinutes()
  const ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours || 12 // the hour '0' should be '12'
  // minutes = minutes < 10 ? '0' + minutes : minutes
  const strTime = hours + ' ' + ampm.toUpperCase()
  return strTime
}

export const TimeSimple = timeStamp => {
  if (timeStamp === '' || !timeStamp) return ''
  try {
    const date = new Date(timeStamp + GMT0)
    return date.toLocaleDateString() + ' ' + formatAMPM(date)
  } catch (e) {
    return 'error time'
  }
}

export function generateWrapUp(picks) {
  return function (info) {
    // if (isEmpty(info)) return {}
    return Object.fromEntries(
      picks.map(one => {
        return [
          one.key,
          {
            ...one,
            value: get(info, one.key, one.default)
          }
        ]
      })
    )
  }
}

export const DialogEdit = 'dialog eidt'
export const DialogNew = 'dialog new'

export const StatusValid = 'Active'
export const StatusDisabeld = 'Disabled'
export const StatusTypes = {
  StatusValid,
  StatusDisabeld
}

export const MaleGender = 'male'
export const FemaleGender = 'female'
export const GenderTypes = {
  MaleGender,
  FemaleGender
}

export const PageSizeKey = 'size'
export const PageSortKey = 'sort'
export const PageCurrentKey = 'current'
export const DefaultPageSizes = [20, 50, 100]
export const DefaultPageSize = DefaultPageSizes[0]
export const Ascending = 'ascending'
export const Descending = 'descending'
export const NoOrder = null
export const PaginationSearchForm = [
  {
    type: Number,
    key: PageSizeKey,
    label: 'Page Size',
    value: DefaultPageSize
  },
  {
    type: Number,
    key: PageCurrentKey,
    label: 'Page Current',
    value: 1
  },
  {
    type: JSON,
    key: PageSortKey,
    label: 'sort',
    value: {}
  }
]
export const InitSearchForm = (DefaultSearchForm, tableHeaders) => {
  const defaultSortIndex = tableHeaders.findIndex(one => one.defaultSort)
  const searchForm = Object.fromEntries(
    cloneDeep([...DefaultSearchForm, ...PaginationSearchForm]).map(one => [
      one.key,
      one
    ])
  )
  if (defaultSortIndex > -1) {
    const defaultSort = tableHeaders[defaultSortIndex]
    searchForm[PageSortKey].value = {
      col: defaultSort.col,
      order: defaultSort?.defaultOrder ?? Ascending
    }
  }
  return searchForm
}
export const DefaultPaginationForm = () => {
  const form = Object.fromEntries(
    PaginationSearchForm.map(one => [one.key, one])
  )
  return cloneDeep(form)
}

export const WarpPaginationSearch = searchForm => {
  searchForm[PageSizeKey] = searchForm?.[PageSizeKey] ?? DefaultPageSize
  searchForm[PageCurrentKey] = searchForm?.[PageCurrentKey] ?? 1
  const sort = searchForm[PageSortKey]
  if (sort.order === Ascending) {
    searchForm.asc = sort.col
  } else if (sort.order === Descending) {
    searchForm.desc = sort.col
  }
  // delete them
  delete searchForm[PageSortKey]
  return searchForm
}

export const DefaultConvertor = (_, val) => val
export const DefaultWarpSearchForm = searchForm => {
  const params = {}
  Object.keys(searchForm).forEach(key => {
    const convertor = searchForm[key]?.convertor ?? DefaultConvertor
    params[key] = convertor(searchForm[key], searchForm[key].value)
  })
  return WarpPaginationSearch(params)
}

export const DisableSortingWrap = headers => {
  headers.forEach(header => {
    header.sortable = false
  })
  return headers
}

export const DefaultBooleanConvertor = (_, val) => val === 'true'

export const CbmIsZeroError = {
  key: 'cbmIsZeroError',
  msg: index => `CBM of row ${index} is 0!`
}

export function getDefaultSort(TableHeaders, pagination) {
  if (!pagination.asc && !pagination.desc) {
    const defaultIndex = TableHeaders.findIndex(one => one.defaultSort)
    if (defaultIndex > -1) {
      pagination.asc = TableHeaders[defaultIndex].col
    }
  }
}

export function cleanString(value) {
  if (typeof value === 'string' && value) return value.trim()
  return value
}

export function toInteger(value) {
  return parseInt(value)
}
